import { fabric } from 'fabric'
import pavPng from '../images/car/pav.png'
import roll_d_Png from '../images/car/roll_d.png'
import roll_s_Png from '../images/car/roll_s.png'
import roll_t_Png from '../images/car/roll_l.png'
import {
    onePointerChange,
    setPathValue,
    // valueInArr
} from './commons'
export default {
    data() {
        return {
            oImg: '',
            carList: [],
            canvas: '',
            midCanvas: '',
            objAll: {},
            getData: '',
            infoAll: {},
            titleShow: {},
            infoItem: {},
            infoItemPointer: {},
            group: {},
            coorlist: {},// 坐标
            nowFiveCoorList: {}, // 即时获取的五段均分坐标
            fiveCoorList: {}, // 五段均分坐标
            alarmList: {}, // 报警数据
            topAlarmList: {}, // 报警数据
            warnList: [],
            topWarnList: [],
            carObj: {},
            warnNum: 0,
            rollNumColor: this.$store.state.rollNumColor,
            icvColor: this.$store.state.icvColor,
            pavTempColor: this.$store.state.pavColor,
            rollTempColor: this.$store.state.rollColor,
            canvasNumClear: 0,
            rollNumList: [],
            rollIcvList: [],
            rollCodeV: 0,
            lastCoorList: [],
            zfCode: 0,
            listB: [],
            listV: [],
            boundary: new Map(),
            boundaryList: [],
            historyList: new Map(),
            workEquipListG: ''
        };
    },

    methods: {
        // 根据工况数据绘图
        drawByWork: function (canvas, midCanvas, data) {
            // console.log('data',data)
            let that = this
            that.workEquipListG = that.workEquipList
            let carPointObj = JSON.parse(localStorage.getItem('carPointObj'))
            if (data.gpsTime) {
                if (data.gpsTime != this.nowDateTimeShow) {
                    that.nowDateTimeShow = data.gpsTime
                    let nowTime = new Date(data.gpsTime).getTime()
                    let reduceTime = nowTime - this.startTime
                    that.percentNum = Math.ceil((reduceTime / this.allTime) * 100)
                    // console.log(that.percentNum)
                }
            }
            this.canvas = canvas
            this.midCanvas = midCanvas
            this.getData = data
            let equipCode = data.equipCode
            let equipType = data.equipType
            let equipName = data.equipName
            let xCoor = data.coordinateX
            let yCoor = data.coordinateY
            let getCoor = [xCoor, yCoor]
            let getLeftCoor = [data.leftBoundaryMiddleCoordinateX, data.leftBoundaryMiddleCoordinateY]
            let getRightCoor = [data.rightBoundaryMiddleCoordinateX, data.rightBoundaryMiddleCoordinateY]
            let getChangeCoor = onePointerChange(getCoor)
            let getChangeLeftCoor = onePointerChange(getLeftCoor)
            let getChangeRightCoor = onePointerChange(getRightCoor)
            let angle = data.angle
            // console.log(this.carWidthMap)
            // 五段坐标
            let carWidth = this.carWidthMap.get(equipCode)
            if (!carWidth) carWidth = 2.385
            console.log(this.carList,'carList')
            
            if(equipCode){
                carPointObj[equipCode] = {
                    left: getChangeCoor[0],
                    top: getChangeCoor[1],
                }
                localStorage.setItem('carPointObj',JSON.stringify(carPointObj))
            }
            if (this.carList.indexOf(equipCode) < 0) {
                this.carList.push(equipCode)
                
                this.carObj[equipCode] = equipName
                console.log(this.scaleCode,'scaleCode')
                
                

                if (equipType == 101) {
                    //console.log('绘制')
                    let carScale = carWidth / (this.scaleCode * 300)
                    fabric.Image.fromURL(pavPng, function (oImage) {
                        that.objAll[equipCode] = oImage.set({
                            left: getChangeCoor[0],
                            top: getChangeCoor[1],
                            originX: 'center',
                            originY: 'center',
                            angle: angle,
                            class: 'group',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                            id: 'group',
                            carName: equipName
                        }).scale(carScale)
                        canvas.add(that.objAll[equipCode])
                    })
                }
                if (equipType == 201) {
                    //console.log('绘制')
                    let carScale = carWidth / (this.scaleCode * 100)
                    fabric.Image.fromURL(roll_d_Png, function (oImage) {
                        that.objAll[equipCode] = oImage.set({
                            left: getChangeCoor[0],
                            top: getChangeCoor[1],
                            originX: 'center',
                            originY: 'center',
                            angle: angle,
                            class: 'group',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                            id: 'group',
                            carName: equipName
                        }).scale(carScale)
                        canvas.add(that.objAll[equipCode])
                    })
                }
                if (equipType == 202) {
                    //console.log('绘制')
                    console.log(getChangeCoor, '202')
                    let carScale = carWidth / (this.scaleCode * 100)
                    fabric.Image.fromURL(roll_s_Png, function (oImage) {
                        that.objAll[equipCode] = oImage.set({
                            left: getChangeCoor[0],
                            top: getChangeCoor[1],
                            originX: 'center',
                            originY: 'center',
                            angle: angle,
                            class: 'group',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                            id: 'group',
                            carName: equipName
                        }).scale(carScale)
                        canvas.add(that.objAll[equipCode])
                    })
                }
                if (equipType == 203) {
                    console.log('绘制', '复压复压复压复压复压复压')
                    console.log(getChangeCoor, '203')
                    let carScale = carWidth / (this.scaleCode * 100)
                    fabric.Image.fromURL(roll_t_Png, function (oImage) {
                        that.objAll[equipCode] = oImage.set({
                            left: getChangeCoor[0],
                            top: getChangeCoor[1],
                            originX: 'center',
                            originY: 'center',
                            angle: angle,
                            class: 'group',
                            selectable: false,
                            hasBorders: false,
                            hasControls: false,
                            id: 'group'+equipCode,
                            carName: equipName
                        }).scale(carScale)
                        canvas.add(that.objAll[equipCode])
                    })
                }
                localStorage.setItem('carList',JSON.stringify(this.carList))
                console.log(this.carList)
                console.log(that.objAll)
                //绘制车辆信息
                // let zoom = this.$store.state.zoom == ''? 1: this.$store.state.zoom
                let x = getChangeCoor[0] + 25 * (0.14 / this.scaleCode)
                let y = getChangeCoor[1] - 30 * (0.14 / this.scaleCode)
                this.coorlist[equipCode] = [getChangeLeftCoor, getChangeRightCoor]
                this.lastCoorList[equipCode] = getCoor
                // 
                if (equipType < 200) {
                    this.carInfoShow(x, y, equipCode, this.parameterPavArr, equipType)
                } else if (equipType == 201) {
                    this.carInfoShow(x, y, equipCode, this.parameterRollDArr, equipType)
                } else if (equipType == 202) {
                    this.carInfoShow(x, y, equipCode, this.parameterRollSArr, equipType)
                } else if (equipType == 203) {
                    this.carInfoShow(x, y, equipCode, this.parameterRollLArr, equipType)
                }
                this.alarmList[equipCode] = ''
                this.topAlarmList[equipCode] = ''

            } else {
                // if (JSON.stringify(this.coorlist[equipCode]) != JSON.stringify([getChangeLeftCoor, getChangeRightCoor])) {
                    //console.log('tocanvas')
                    let x = getChangeCoor[0] + 10 * (0.14 / this.scaleCode)
                    let y = getChangeCoor[1] - 10 * (0.14 / this.scaleCode)
                    if (equipType < 200) {
                        this.carInfoShow(x, y, equipCode, this.parameterPavArr, equipType)
                    } else if (equipType == 201) {
                        this.carInfoShow(x, y, equipCode, this.parameterRollDArr, equipType)
                    } else if (equipType == 202) {
                        this.carInfoShow(x, y, equipCode, this.parameterRollSArr, equipType)
                    } else if (equipType == 203) {
                        this.carInfoShow(x, y, equipCode, this.parameterRollLArr, equipType)
                    }
                    this.toPlay(this.objAll[equipCode], this.group[equipCode], getChangeCoor[0], getChangeCoor[1], angle)
                    if (this.dimension == 0) {
                        console.log('tm')

                    } else if (this.dimension == 1) {
                        // console.log([getChangeLeftCoor,this.coorlist[equipCode][0],this.coorlist[equipCode][1],getChangeRightCoor])

                        let carPath = setPathValue([getChangeLeftCoor, this.coorlist[equipCode][0], this.coorlist[equipCode][1], getChangeRightCoor])

                        let fillColor = equipType == 101 ? '#C0C0C0' : '#32CD32'
                        if (this.lastCoorList[equipCode][0] == '0.0' || this.lastCoorList[equipCode][1] == '0.0' || getCoor[0] == '0.0' || getCoor[1] == '0.0') {
                            this.midCanvas.add(new fabric.Path(carPath, {
                                fill: 'RGBA(0,0,0,0)',
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                                class: 'carPath',
                                id: 'carPath'
                            }))
                        } else {
                            this.midCanvas.add(new fabric.Path(carPath, {
                                fill: fillColor,
                                selectable: false,
                                hasBorders: false,
                                hasControls: false,
                                class: 'carPath',
                                id: 'carPath'
                            }))
                        }


                    } else if (this.dimension != 1) {
                        if (equipType > 200) {
                            this.nowFiveCoorList = {}
                            this.fiveCoorSet(this.nowFiveCoorList, data.list, equipCode)
                            console.log(this.nowFiveCoorList)
                            for (let key in this.nowFiveCoorList) {
                                // //console.log(key,this.nowFiveCoorList[key])
                                // //console.log(key,this.fiveCoorList[key])
                                let iStr = key.toString()
                                let iCode = (iStr.substr(iStr.length - 1, 1)) * 1
                                if (iCode < 5) {
                                    var fillColor = ''
                                    let nextCode = key.substring(0, key.length - 1) + (key.substring(key.length - 1) * 1 + 1 + '')
                                    console.log(key)
                                    console.log(nextCode)
                                    console.log([this.nowFiveCoorList[key], this.nowFiveCoorList[nextCode], this.fiveCoorList[nextCode], this.fiveCoorList[key]])
                                    let carPath = setPathValue([this.nowFiveCoorList[key], this.nowFiveCoorList[nextCode], this.fiveCoorList[nextCode], this.fiveCoorList[key]])
                                    //console.log(carPath)
                                    if (this.dimension == 2) {
                                        console.log(data.list[iCode].rolledPassNum * 1)
                                        fillColor = Math.ceil(data.list[iCode].rolledPassNum * 1) < 20 ? this.rollNumColor[Math.ceil(data.list[iCode].rolledPassNum * 1)] : this.rollNumColor[20]
                                    } else if (this.dimension == 3) {
                                        console.log(data.list[iCode].icv * 1)
                                        if (data.list[iCode].icv * 1 < 64) {
                                            fillColor = this.icvColor['64']
                                        } else if (data.list[iCode].icv * 1 < 74) {
                                            fillColor = this.icvColor['74']
                                        } else if (data.list[iCode].icv * 1 < 84) {
                                            fillColor = this.icvColor['84']
                                        } else if (data.list[iCode].icv * 1 < 94) {
                                            fillColor = this.icvColor['94']
                                        } else {
                                            fillColor = this.icvColor['100']
                                        }

                                    } else if (this.dimension == 4) {
                                        let getNum = Object.keys(this.pavTempColor)
                                        getNum.sort()
                                        for(let i=0;i<getNum.length;i++){
                                            if(data.list[iCode].pavingTemperature*1 < getNum[i]*1){
                                                fillColor = this.pavTempColor[getNum[i]]
                                                i=getNum.length
                                            }
                                        }
                                    } else if (this.dimension == 5) {
                                        let getNum = Object.keys(this.rollTempColor)
                                        getNum.sort()
                                        for(let i=0;i<getNum.length;i++){
                                            if(data.list[iCode].rollingTemperature*1 < getNum[i]*1){
                                                fillColor = this.rollTempColor[getNum[i]]
                                                i=getNum.length
                                            }
                                        }
                                    }
                                    if (this.lastCoorList[equipCode][0] == '0.0' || this.lastCoorList[equipCode][1] == '0.0' || getCoor[0] == '0.0' || getCoor[1] == '0.0') {
                                        this.midCanvas.add(new fabric.Path(carPath, {
                                            fill: 'RGBA(0,0,0,0)',
                                            selectable: false,
                                            hasBorders: false,
                                            hasControls: false,
                                            class: 'carPath',
                                            id: 'carPath'
                                        }))
                                    } else {
                                        this.midCanvas.add(new fabric.Path(carPath, {
                                            fill: fillColor,
                                            selectable: false,
                                            hasBorders: false,
                                            hasControls: false,
                                            class: 'carPath',
                                            id: 'carPath'
                                        }))
                                    }

                                }

                            }
                        }
                    }
                    this.canvasNumClear = this.canvasNumClear + 1
                    // console.log(this.canvasNumClear)
                    if (this.canvasNumClear > 1998) {
                        const loading = this.$loading({
                            lock: true,
                            text: '',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        setTimeout(() => {
                            loading.close();
                        }, 2000);
                    }
                    if (this.canvasNumClear > 2000) {
                        this.coverCanvasToImage()
                    }

                // }
                this.coorlist[equipCode] = [getChangeLeftCoor, getChangeRightCoor] // 轨迹信息更新
                this.lastCoorList[equipCode] = getCoor
                if (equipType > 200) {
                    this.fiveCoorSet(this.fiveCoorList, data.list, equipCode)
                }


                // 报警信息
                this.carAlarm(equipCode, data.etAlarmList)
                this.carTopAlarm(equipCode, data.etTopAlarmList)

            }

        },
        drawByPageZ: function (data) {
            // console.log(data)
            if (data.pileNum) {
                //获取桩号
                let getNum = (data.pileNum + '').split(".")
                let pileNum = ((getNum[0] * 1) / 1000 + '').split(".")
                let num = ''
                if (getNum.length == 1) {
                    num = 'K' + pileNum[0] + '+' + pileNum[1]
                } else {
                    num = 'K' + pileNum[0] + '+' + pileNum[1] + '.' + (getNum[1] + '').substring(0, 1)
                }
                // console.log(num)
                //获取偏移量
                let code = Math.floor(data.direction * 1)
                var yAxisData = this.$store.state.roadWidth;
                if (code < 10) {
                    if (this.xAxisValue.indexOf(num) >= 0) {
                        let setNum = (this.xAxisValue.indexOf(num)) * yAxisData.indexOf(code) + yAxisData.indexOf(code)
                        this.rollTimesList[setNum][2] = data.rolledPassNumber
                        this.rollIcvList[setNum][2] = data.icv
                    }
                }
            }
            this.rollCodeV = this.rollCodeV + 1
            if (this.rollCodeV >= 100) {
                let startT = this.rollTimesHeat.getOption().dataZoom[0].start
                let endT = this.rollTimesHeat.getOption().dataZoom[0].end
                let paramsT = paramsT
                this.paramsT.startT = startT
                this.paramsT.endT = endT

                let startI = this.rollIcvHeat.getOption().dataZoom[0].start
                let endI = this.rollIcvHeat.getOption().dataZoom[0].end
                let paramsI = paramsI
                this.paramsI.startI = startI
                this.paramsI.endI = endI
                const colorBox = this.colorBox
                const colorBox1 = this.colorBox1
                let chartOption = {
                    visualMap: {
                        type: "piecewise",
                        min: 0,
                        max: 10,
                        calculable: true,
                        realtime: false,
                        orient: "horizontal",
                        left: "center",
                        bottom: "15%",
                        show: false,
                        pieces: [
                            // { min: 20, max: 21 },
                            // { min: 0, max: 1 },
                            { min: 1, max: 1 },
                            { min: 2, max: 2 },
                            { min: 3, max: 3 },
                            { min: 4, max: 4 },
                            { min: 5, max: 5 },
                            { min: 6, max: 6 },
                            { min: 7, max: 7 },
                            { min: 8, max: 8 },
                            { min: 9, max: 9 },
                            { min: 10, max: 10 },
                            { min: 11, max: 11 },
                            { min: 12, max: 12 },
                            { min: 13, max: 13 },
                            { min: 14, max: 14 },
                            { min: 15, max: 15 },
                            { min: 16, max: 16 },
                            { min: 17, max: 17 },
                            { min: 18, max: 18 },
                            { min: 19, max: 19 },
                            { min: 20 },
                        ],
                        color: colorBox,
                    },
                    tooltip: {
                        position: "top",
                        formatter: function (a) {
                            console.log(a)
                            let str = a.data[2] ? a.data[2] : '暂无'
                            return a.name + ':' + ' ' + str;
                        }
                    },
                    animation: false,
                    grid: {
                        height: "70%",
                        top: "10%",
                    },
                    xAxis: {
                        type: "category",
                        data: this.xAxisValue,
                        splitArea: {
                            show: false,
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#194793'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: "category",
                        data: this.yData,
                        splitArea: {
                            show: false,
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['#194793']
                            }
                        },
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#878787'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    series: [
                        {
                            // name: "Punch Card",
                            type: "heatmap",
                            data: this.rollTimesList,
                            label: {
                                show: false,
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                    ],
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        realtime: true,
                        start: this.paramsT.startT,
                        end: this.paramsT.endT,
                        handleSize: '10%',
                        height: 10,
                        handleStyle: {
                            borderWidth: 2
                        },
                        bottom: '10%',
                        borderColor: '#0492FF',
                        fillerColor: '#265DFD',
                        textStyle: {
                            color: '#ffffff'
                        }
                    }, {
                        type: 'inside',
                        xAxisIndex: [0],
                    }, {
                        type: 'slider',
                        yAxisIndex: [0],
                        show: false,
                        zoomLock: true
                    }]
                };
                this.rollTimesHeat.setOption(chartOption);
                let chartOption1 = {
                    visualMap: {
                        type: "piecewise",
                        min: 0,
                        max: 10,
                        calculable: true,
                        realtime: false,
                        orient: "horizontal",
                        left: "center",
                        bottom: "15%",
                        show: false,
                        pieces: [
                            { min: 1, max: 64 },
                            { min: 65, max: 74 },
                            { min: 75, max: 84 },
                            { min: 85, max: 94 },
                            { min: 95 },
                        ],
                        color: colorBox1,
                    },
                    tooltip: {
                        position: "top",
                        formatter: function (a) {
                            console.log(a)
                            let str = a.data[2] ? a.data[2] : '暂无'
                            return a.name + ':' + ' ' + str;
                        }
                    },
                    animation: false,
                    grid: {
                        height: "70%",
                        top: "10%",
                    },
                    xAxis: {
                        type: "category",
                        data: this.xAxisValue,
                        splitArea: {
                            show: false,
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#194793'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: {
                        type: "category",
                        data: this.yData,
                        splitArea: {
                            show: false,
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['#194793']
                            }
                        },
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#878787'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    series: [
                        {
                            // name: "Punch Card",
                            type: "heatmap",
                            data: this.rollIcvList,
                            label: {
                                show: false,
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                    ],
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        realtime: true,
                        start: this.paramsI.startI,
                        end: this.paramsI.endI,
                        handleSize: '10%',
                        height: 10,
                        handleStyle: {
                            borderWidth: 2
                        },
                        bottom: '10%',
                        borderColor: '#0492FF',
                        fillerColor: '#265DFD',
                        textStyle: {
                            color: '#ffffff'
                        }
                    }, {
                        type: 'inside',
                        xAxisIndex: [0],
                    }, {
                        type: 'slider',
                        yAxisIndex: [0],
                        show: false,
                        zoomLock: true
                    }]
                };
                this.rollIcvHeat.setOption(chartOption1);
                this.rollCodeV = 0
            }

        },
        drawByPageZF: function (data,contextM) {
            console.log(data)
            console.log(this.imgX)
            console.log(this.imgY)
            console.log(this.imgScale)
            console.log(contextM)
            let colorSet = ''
            if (this.infoTypeItemNumSet == 1) {
                colorSet = Math.ceil(data.rolledPassNumber * 1) < 20 ? this.rollNumColor[Math.ceil(data.rolledPassNumber * 1)] : this.rollNumColor[20]
            } else {
                colorSet = ''
            }
            let equipCode = data.equipCode
            let nowBoundLeft = onePointerChange([data.leftBoundaryMiddleCoordinateX, data.leftBoundaryMiddleCoordinateY])
            let nowBoundRight = onePointerChange([data.rightBoundaryMiddleCoordinateX, data.rightBoundaryMiddleCoordinateY])
            // console.log(this.boundaryList)
            if (this.boundaryList.indexOf(equipCode) < 0) {
                this.boundaryList.push(equipCode)
                this.boundary[equipCode] = [nowBoundLeft,nowBoundRight]
                this.historyList[equipCode] = []
                this.historyList[equipCode].push([nowBoundLeft, nowBoundRight,data.rolledPassNumber,data.icv])
            } else {
                // console.log(this.boundary)
                let oldPoint = [this.boundary[equipCode][0], this.boundary[equipCode][1]]
                let nowPoint = [nowBoundLeft, nowBoundRight]
                // console.log(oldPoint)
                // console.log(nowPoint)
                contextM.lineWidth = '1'
                contextM.beginPath();
                contextM.strokeStyle = colorSet;
                contextM.moveTo(oldPoint[0][0]*this.imgScale+this.imgX,oldPoint[0][1]*this.imgScale+this.imgY)
                contextM.lineTo(oldPoint[1][0]*this.imgScale+this.imgX,oldPoint[1][1]*this.imgScale+this.imgY)
                contextM.lineTo(nowPoint[1][0]*this.imgScale+this.imgX,nowPoint[1][1]*this.imgScale+this.imgY)
                contextM.lineTo(nowPoint[0][0]*this.imgScale+this.imgX,nowPoint[0][1]*this.imgScale+this.imgY)
                contextM.fillStyle = colorSet;
                contextM.fill();
                contextM.stroke();
                this.historyList[equipCode].push([nowBoundLeft, nowBoundRight])
                this.boundary[equipCode] = [nowBoundLeft,nowBoundRight,data.rolledPassNumber,data.icv]
            }
        },
        drawNone: function (data) {
            console.log(data, 'out')
        },
        //canvas to img and clear canvas
        coverCanvasToImage: function () {
            let that = this
            this.midCanvas.setViewportTransform([1, 0, 0, 1, 0, 0])
            this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0])
            setTimeout(function () {
                var image = new Image()
                let canvas = document.getElementById('midCanvas')
                image.src = canvas.toDataURL("image/png")
                that.midCanvas.clear()
                that.canvasNumClear = 0
                fabric.Image.fromURL(image.src, function (oImage) {
                    let setImg = oImage.set({
                        left: 0,
                        top: 0,
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                    })
                    that.midCanvas.add(setImg)
                })
            }, 100)

        },
        //五均分坐标
        fiveCoorSet: function (obj, arr, equipCode) {
            let setArr = arr
            for (let i = 0; i < setArr.length; i++) {
                let coor = onePointerChange([setArr[i].x, setArr[i].y])
                obj[equipCode + i] = coor
            }
            // //console.log(obj)
        },
        // 绘制车辆行驶轨迹（轨迹维度）
        carTrajectory: function () {

        },
        carAlarm: function (equipCode, arr) {
            if (JSON.stringify(this.alarmList[equipCode]) != JSON.stringify(arr)) {
                //console.log('warnUndata')
                this.warnList = []
                this.alarmList[equipCode] = arr
                for (let key in this.alarmList) {
                    let obj = {
                        equipName: this.carObj[key],
                        equipCode: key,
                        list: this.alarmList[key]
                    }
                    if (this.alarmList[key] != null) {
                        this.warnList.push(obj)
                    }
                }
                this.warnNum = this.warnList.length
            }

        },
        carTopAlarm: function (equipCode, arr) {
            if (JSON.stringify(this.topAlarmList[equipCode]) != JSON.stringify(arr)) {
                //console.log('warnUndata')
                this.topWarnList = []
                this.topAlarmList[equipCode] = arr
                for (let key in this.topAlarmList) {
                    let obj = {
                        equipName: this.carObj[key],
                        equipCode: key,

                        list: this.topAlarmList[key]
                    }
                    if (this.topAlarmList[key] != null) {
                        this.topWarnList.push(obj)
                    }
                }
                if (this.topWarnList.length > 0) {
                    this.$refs.warnNumContent.style.right = 360 + 'px'
                    this.$refs.warnContent.style.right = 0 + 'px'
                    this.warnShowCode = 1
                } else if(this.topWarnList.length == 0){
                    this.$refs.warnNumContent.style.right = 0 + 'px'
                    this.$refs.warnContent.style.right = -360 + 'px'
                    this.warnShowCode = 0
                }
                // console.log(this.topWarnList, 'topWarnList')
                // this.warnNum = this.warnList.length
            }


        },
        // 车辆文字信息展示
        carInfoShow: function (x, y, equipCode, setArr, type) {
            console.log('type',type)
            let that = this
            let canvasArr = this.canvas.getObjects()
            for (let i = 0; i < canvasArr.length; i++) {
                if (canvasArr[i].id == "groupCarInfo" + equipCode) {
                    this.canvas.remove(canvasArr[i])
                }
            }
            let yDev = 0 //top方向偏移
            if (setArr.length == 0) {
                yDev = 35
            } else if (setArr.length <= 2) {
                yDev = 51
            } else if (setArr.length <= 4) {
                yDev = 67
            } else {
                yDev = 83
            }
            let groupList = []

            //边框

            let contentArr = [[x, y], [x + 163, y], [x + 163, y + yDev], [x, y + yDev], [x, y + yDev - 10], [x - 7, y + yDev - 18], [x, y + yDev - 26]]
            let pathV = setPathValue(contentArr)
            this.infoAll[equipCode] = new fabric.Path(pathV)
            this.infoAll[equipCode].set({ fill: 'rgba(255,255,255,0.3)' })
            groupList.push(this.infoAll[equipCode])
            //标题
            // this.titleShow[equipCode] = new fabric.Text(this.getData.equipName)
            // console.log(that.workEquipListG)
            this.titleShow[equipCode] = new fabric.Text(that.workEquipListG[equipCode])
            this.titleShow[equipCode].set({
                fontSize: 14,
                left: x + 12,
                top: y + 9,
                fill: '#282828',
                fontWeight: '600'
            })
            groupList.push(this.titleShow[equipCode])
            //具体内容
            let leftCode = ''
            let topCode = ''
            for (let i = 0; i < setArr.length; i++) {
                if (i % 2 == 0) {
                    leftCode = x + 22
                    topCode = y + 32 + i * 8
                } else {
                    leftCode = x + 103
                    topCode = y + 32 + (i - 1) * 8
                }
                let dw = ''
                switch (setArr[i]) {
                    case 'icv':
                        break
                    case 'speed':
                        if (type < 200) {
                            dw = 'm/min'
                        } else {
                            dw = 'Km/h'
                        }
                        break
                    case 'temperature':
                        dw = '℃'
                        break
                    case 'oilmass':
                        if (type < 200) {
                            dw = 'L'
                        } else {
                            dw = '%'
                        }
                        break
                    case 'frequencyVal':
                        dw = 'Hz'
                        break
                    case 'swingVal':
                        dw = 'mm'
                        break
                }
                this.getData[setArr[i]] = this.getData[setArr[i]] ? this.getData[setArr[i]] : '--'
                this.infoItem[equipCode] = new fabric.Text(this.getData[setArr[i]] + dw)
                this.infoItem[equipCode].set({
                    fontSize: 14,
                    left: leftCode,
                    top: topCode,
                    fill: '#282828'
                })
                this.infoItemPointer[equipCode] = new fabric.Circle({
                    radius: 2,
                    fill: '#E24747',
                    left: leftCode - 8,
                    top: topCode + 7,
                    originX: 'center',
                    originY: 'center'
                })
                groupList.push(this.infoItem[equipCode])
                groupList.push(this.infoItemPointer[equipCode])
            }
            this.group[equipCode] = new fabric.Group(groupList)
            this.group[equipCode].set({
                class: 'groupCar groupCarInfo' + equipCode,
                selectable: false,
                hasBorders: false,
                hasControls: false,
                id: 'groupCarInfo' + equipCode
            }).scale(0.4 * (0.24 / this.scaleCode))
            this.canvas.add(this.group[equipCode])
        },
        // 车辆运行动画函数
        toPlay: function (obj, objT, toX, toY, toAngle) {
            if (obj) {
                obj.animate('top', toY, {
                    duration: 600,
                    // onChange: this.canvas.renderAll.bind(this.canvas)
                })
                obj.animate('left', toX, {
                    duration: 600,
                    // onChange: this.canvas.renderAll.bind(this.canvas)
                })
                obj.animate('angle', toAngle, {
                    duration: 200,
                    // onChange: this.canvas.renderAll.bind(this.canvas)
                })

                // objT.animate('top',toY-50,{
                //     duration: 600,
                //     // onChange: this.canvas.renderAll.bind(this.canvas)
                // })
                // objT.animate('left',toX+35,{
                //     duration: 600,
                //     onChange: this.canvas.renderAll.bind(this.canvas)
                // })
            }

        }

    }
};